import { useColorMode } from "@/components/layouts/ColorModeContext";
import { getDataColors, type DataColors } from "./bands";

/** Data colours for the active mode. `getDataColors` is the pure form. */
export const useDataColors = (): DataColors => {
  const { colorMode } = useColorMode();

  return getDataColors(colorMode);
};
